import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import FontsDropZone from "../../../common/FontsDropZone";
import {
  deleteFont,
  fetchFonts
} from "../../../../_actions/appActions";
import TextMyFont from "./TextMyFont";
import TLDRBrowseMoreFontsModal from "../../editorToolbar/textEditorToolbar/fontBrowser/TLDRBrowseMoreFontsModal";
import { Box, Button, Center, Spinner } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import TLDRInfiniteScroll from "../../../common/TLDRInfiniteScroll";
import axios from "axios";
import { isEmpty } from "lodash";

function TextMyFontsList(props) {
  const { canvasRef, t, myFonts, page, hasMore } = props;
  const signal = axios.CancelToken.source();
  const [showMoreFontBrowser, setShowMoreFontBrowser] = useState(false);
  const [loading, isLoaded] = useState(false);

  useEffect(() => {
   if(isEmpty(myFonts)) fetchFonts(1);
  }, []);

  function fetchFonts(page) {
    isLoaded(true);
    props.fetchFonts(props, signal, page).then(() => {
      isLoaded(false);
    });
  }

  function loadMoreFonts() {
    isLoaded(true);
    props.fetchFonts(props, signal, page).then((responseData) => {
      isLoaded(false);
      const fontsList = responseData.results;
      canvasRef?.handler.fontHandler.addFonts(fontsList);
    });
  }

  const hideMoreFontBrowser = () => {
    setShowMoreFontBrowser(false);
  };

  const childElements = myFonts.map((font, index) => {
    return (
      <TextMyFont
        key={index}
        font={font}
        addToArtboard={true}
        canvasRef={canvasRef}
      />
    );
  });

  return (
    <>
      <Box pr={4}>
        {" "}
        {/* {removed padding right of main panel container for scroller UI, so adding padding right} */}
        <FontsDropZone
          className="tldr-fonts-dropzone"
          checkForCustomFonts={true}
          buttonWidth={100}
        />
      </Box>
      <hr
        className="tldr-hr"
        style={{
          marginLeft: "4px",
          marginRight: "0px",
          width: `calc(100% - 24px)`,
        }}
      />
      <Button
        variant="solid"
        onClick={() => setShowMoreFontBrowser(true)}
        size="md"
        mb={3}
        w={`calc(100% - 16px)`}
        mt={4} // removed padding right of main panel container for scroller UI, so reducing width
      >
        {t("fonts.manage_fonts_btn")}
      </Button>

      <div
        className="grid-gallery my-font-gallery"
        id="tldr-my-fonts"
        style={{
          "::WebkitScrollbarTrackPiece": {
            backgroundColor: 'transparent !important'
          }
        }}
      >
        <Box pr={5}>
          <TLDRInfiniteScroll
            className="view-all-templates-infinite-scroll"
            childrens={childElements}
            hasMore={hasMore}
            loadMoreData={loadMoreFonts}
            scrollableTarget={"tldr-my-fonts"}
            loaded={loading}
            showLoading
          />
          {loading && (
            <Center mb="3">
              <Spinner size="sm" color="brand.primary" />
            </Center>
          )}
        </Box>
      </div>

      <TLDRBrowseMoreFontsModal
        show={showMoreFontBrowser}
        onHide={hideMoreFontBrowser}
        canvasRef={canvasRef}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  myFonts: state.app.myFontList.filter((font) => {
    return font?.organization > 0;
  }),
  hasMore: state.app.loadMoreFonts,
  page: state.app.pageFonts,
});

const mapDispatchToProps = (dispatch) => ({
  deleteFont: (fontId, props) => dispatch(deleteFont(fontId, props)),
  fetchFonts: (props, cancelToken, page) =>
    dispatch(fetchFonts(props, cancelToken, page))
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(TextMyFontsList)
);
